<template>
  <div
    v-if="founder"
    class="founder founder--full"
    :class="{
      [`bg-${bgTheme}`]: true,
      [`c-${theme}`]: true,
    }">
    <div class="founder-content-wrap flex">
      <div
        class="founder-heading founder-heading--mobile l:hidden width-expand text-center">
        <h2
          class="founder-title founder-title--mobile flex-middle flex-wrap margin-remove width-expand text-center">
          <div v-if="canEdit" class="edit-controls flex gap-m">
            <icon-halo
              v-if="canEdit"
              class="cursor-pointer"
              style="top: var(--margin-s); inset-inline-end: var(--margin-s)"
              halo-theme="danger"
              theme="bg"
              icon="trash"
              :size="1"
              @click="startFounderDeletion()"></icon-halo>
            <quick-edit
              v-if="canEdit"
              halo-theme="bg"
              theme="lead"
              :editor="founderEditor"
              position="inline"
              :size="1"
              :fields="'all'"></quick-edit>
          </div>
          <span class="text-center margin-auto block">
            {{ tt(founder.fullName) }}
          </span>

          <div class="founder-meta width-expand">
            <span
              v-if="founder.originCountry && founder.originCountry != ''"
              class="text-m">
              {{ translateUcFirst(founder.originCountry) }}
            </span>
            <span
              v-if="founder.birthYear && founder.birthYear != '0'"
              class="text-m text-center">
              <span>, </span>
              <span v-if="founder.birthYear && founder.birthYear != '0'">{{
                  founder.birthYear
                }}</span>

              <span v-else="">&nbsp;</span>
              <span v-if="founder.deathYear && founder.deathYear !== '0'"
              >&nbsp;-&nbsp;</span
              >
              <span v-if="founder.deathYear && founder.deathYear !== '0'">{{
                  founder.deathYear
                }}</span>
            </span>
          </div>
        </h2>
      </div>
      <div class="founder-bio text-l">
        <div class="founder-heading l:visible">
          <h2 class="founder-title flex-middle flex-wrap margin-remove">
            <div v-if="canEdit" class="edit-controls flex gap-m">
              <icon-halo
                v-if="canEdit"
                class="cursor-pointer"
                style="top: var(--margin-s); inset-inline-end: var(--margin-s)"
                halo-theme="danger"
                theme="bg"
                icon="trash"
                :size="1"
                @click="startFounderDeletion()"></icon-halo>
              <quick-edit
                v-if="canEdit"
                halo-theme="bg"
                theme="lead"
                :editor="founderEditor"
                position="inline"
                :size="1"
                :fields="[
                  'fullName',
                  'originCountry',
                  'birthYear',
                  'deathYear',
                  'description',
                ]"></quick-edit>
            </div>
            <span>
              {{ tt(founder?.fullName) }}
            </span>
            <div class="founder-meta width-expand">
              <span
                v-if="founder.originCountry && founder.originCountry != ''"
                class="text-m">
                {{ translateUcFirst(founder.originCountry) }}
              </span>
              <span v-if="founder.birthYear" class="text-m text-center">
                <span v-if="hasCountryAndYear">, </span>
                <span v-if="founder.birthYear && founder.birthYear != '0'">{{
                    founder.birthYear
                  }}</span>
                <span v-else="">&nbsp;</span>
                <span v-if="founder.deathYear && founder.deathYear !== '0'"
                >&nbsp;-&nbsp;</span
                >
                <span v-if="founder.deathYear && founder.deathYear !== '0'">{{
                    founder.deathYear
                  }}</span>
              </span>
            </div>
          </h2>
        </div>
        <!--
                <div
                  v-if="founder.youtubeVideos && youtubeVideos?.length > 0"
                  class="video-container margin-l-bottom relative">
                  <quick-edit
                    v-if="canEdit"
                    halo-theme="bg"
                    theme="lead"
                    :editor="founderEditor"
                    :fields="['youtubeVideos']"
                    position="absolute-border-top"
                    size="2"></quick-edit>

                  <slider
                    ref="videoSlider"
                    class="video-slider"
                    style="z-index: var(--z-1)"
                    :config="videoSliderConfig">
                    <template #default>
                      <slide v-for="(video, index) of youtubeVideos" :key="index">
                        <div
                          class="video-slide flex-center flex-middle padding-xs relative flex-column"
                          style="height: 100%; width: 100%">
                          <img
                            class="video-preview-image cursor-pointer"
                            style="object-fit: cover"
                            :src="`https://img.youtube.com/vi/${video?.youtubeId}/hqdefault.jpg`"
                            :alt="'founder video'"
                            @click="playLargeVideo(video.youtubeId)" />
                          <icon-halo
                            class="play-icon-overlay z-level-2 absolute-center cursor-pointer"
                            halo-theme="lead"
                            theme="bg"
                            size="2"
                            icon="mc-play"
                            @click="playLargeVideo(video.youtubeId)"></icon-halo>

                          <div
                            v-if="video.title && video.title != ''"
                            class="video-description margin-s-top text-center">
                            <spoiler
                              class="image-title animate__fadeIn animate--fast"
                              max-height="30"
                              controls-theme="bg-1"
                              :controls-style="{ 'justify-content': 'center' }">
                              <template #default>
                                <span>{{ video.title }}</span>
                              </template>
                              <template
                                #controls="{
                                  isExpanded,
                                  expand,
                                  contract,
                                  shouldShowControls,
                                }">
                                <div
                                  v-if="shouldShowControls"
                                  class="flex-center margin-s-top padding-s-bottom l:padding-xl-bottom">
                                  <form-button
                                    size="s"
                                    v-if="shouldShowControls"
                                    @click="isExpanded ? contract() : expand()"
                                    theme="inverse"
                                    :icon-end="
                                      isExpanded ? 'chevron-up' : 'chevron-down'
                                    "
                                    :text="
                                      isExpanded
                                        ? 'ls.spoiler.showLess'
                                        : 'ls.spoiler.showMore'
                                    "></form-button>
                                </div>
                                <div v-else></div>
                              </template>
                            </spoiler>
                          </div>
                        </div>
                      </slide>
                    </template>
                    <template #navigation-prev>
                      <span style="display: none"></span>
                    </template>
                    <template #navigation-next>
                      <span style="display: none"></span>
                    </template>
                  </slider>

                  <div
                    v-if="hasMultipleVideos"
                    class="swiper-button-prev-custom padding-xs"
                    :class="{ maximized: sliderMaximized }"
                    @click.prevent.stop="$refs['videoSlider'].prev()">
                    <icon icon="chevron-inline-start" :size="2" :theme="theme"></icon>
                  </div>
                  <div
                    v-if="hasMultipleVideos"
                    class="swiper-button-next-custom padding-xs"
                    :class="{ maximized: sliderMaximized }"
                    @click.prevent.stop="$refs['videoSlider'].next()">
                    <icon icon="chevron-inline-end" :size="2" :theme="theme"></icon>
                  </div>
                </div>
                -->

        <content-blocks :content="founder.description"></content-blocks>
      </div>
      <div class="founder-media flex-center gap-xl relative">
        <div
          v-if="
            canEdit && (!founder.youtubeVideos || youtubeVideos?.length < 1)
          "
          class="edit-video-cta margin-xl-bottom absolute z-level-2" style="position: absolute;">
          <form-button
            v-if="canEdit"
            theme="success"
            icon="mc-play"
            text="ls.founder.editAddVideoCta"
            @click="founderEditor.startEdit(['youtubeVideos'])" />
        </div>
        <div
          v-if="sliderMaximized"
          class="media-slider-placeholder margin-m-bottom flex flex-center"></div>
        <div
          class="slider-wrapper flex-column flex-middle flex-center relative margin-m-bottom flex flex-center">
          <div
            v-if="displayMedia && displayMedia.length > 0"
            class="media-slider relative flex flex-center"
            :class="sliderMaximized ? 'maximized animate__fadeIn animate--delay-200' : ''">
            <icon-halo
              v-if="sliderMaximized"
              class="maximized-slider-close cursor-pointer"
              :size="1.6"
              theme="inverse"
              halo-theme="bg"
              :halo-ratio="0.4"
              icon="x"
              @click="sliderMaximized = false" />

            <slider
              v-if="displayMedia && displayMedia?.length > 0"
              ref="imageSlider"
              class="image-slider  animate__fadeIn animate--delay-200"
              style="z-index: var(--z-1)"
              :config="mediaSliderConfig">
              <template #default>
                <!--
                <icon-halo
                  v-if="canEdit"

                  class="cursor-pointer absolute z-level-2"
                  style="inset-inline-start: var(--margin-s); top: var(--margin-s)"
                  halo-theme="success"
                  theme="bg"
                  icon="plus"
                  size="2"
                  @click="startCreatingFounderMedia"></icon-halo>-->
                <slide v-for="(video, index) of youtubeVideos" :key="index">
                  <div
                    class="relative video-slide flex-center flex-middle padding-xs relative flex-column"
                    style="height: 100%; width: 100%">
                    <div
                      class="edit-ui absolute flex-center gap-m z-level-2"
                      style="top: var(--margin-s)">
                      <quick-edit
                        v-if="canEdit"
                        :editor="founderEditor"
                        :fields="['youtubeVideos']"
                        halo-theme="bg"
                        theme="lead"
                        position=""
                        :size="2"
                        position-offset="24"></quick-edit>
                    </div>

                    <img
                      class="video-preview-image cursor-pointer"
                      style="object-fit: cover"
                      :src="`https://img.youtube.com/vi/${video?.youtubeId}/hqdefault.jpg`"
                      :alt="'founder video'"
                      @click="playLargeVideo(video.youtubeId)" />
                    <icon-halo
                      class="play-icon-overlay z-level-2 absolute-center cursor-pointer"
                      halo-theme="lead"
                      theme="bg"
                      :size="2"
                      icon="mc-play"
                      @click="playLargeVideo(video.youtubeId)"></icon-halo>

                    <div
                      v-if="video.title && video.title != ''"
                      class="video-description margin-s-top text-center">
                      <spoiler
                        class="image-title animate__fadeIn animate--fast"
                        max-height="30"
                        controls-theme="bg-1"
                        :controls-style="{ 'justify-content': 'center' }">
                        <template #default>
                          <span>{{ video.title }}</span>
                        </template>
                        <template
                          #controls="{
                            isExpanded,
                            expand,
                            contract,
                            shouldShowControls,
                          }">
                          <div
                            v-if="shouldShowControls"
                            class="flex-center margin-s-top padding-s-bottom l:padding-xl-bottom">
                            <form-button
                              size="s"
                              v-if="shouldShowControls"
                              @click="isExpanded ? contract() : expand()"
                              theme="inverse"
                              :icon-end="
                                isExpanded ? 'chevron-up' : 'chevron-down'
                              "
                              :text="
                                isExpanded
                                  ? 'ls.spoiler.showLess'
                                  : 'ls.spoiler.showMore'
                              "></form-button>
                          </div>
                          <div v-else></div>
                        </template>
                      </spoiler>
                    </div>
                  </div>
                </slide>
                <slide
                  v-for="(founderMediaItem, index) in displayMedia"
                  :key="index">
                  <div
                    class="founder-media-slide flex-center flex-middle padding-xs relative flex-column"
                    :class="{'founder-media-slide__has-title' : isNonEmptyString(founderMediaItem.title)}"
                    style="height: 100%; width: 100%">
                    <div
                      v-if="isMounted"
                      class="edit-ui absolute flex-center gap-m z-level-2"
                      style="top: var(--margin-s)">
                      <icon-halo
                        v-if="
                          canEdit && displayMedia && displayMedia.length > 0
                        "
                        class="cursor-pointer z-level-2"
                        style="
                          inset-inline-start: var(--margin-s);
                          top: var(--margin-s);
                        "
                        halo-theme="success"
                        theme="bg"
                        icon="plus"
                        :size="2"
                        @click="startCreatingFounderMedia"></icon-halo>
                      <icon-halo
                        v-if="
                          canEdit && displayMedia && displayMedia.length > 0
                        "
                        class="cursor-pointer z-level-2"
                        style="
                          inset-inline-start: var(--margin-s);
                          top: var(--margin-s);
                        "
                        halo-theme="bg"
                        theme="lead"
                        icon="arrows-sort"
                        :size="2"
                        @click="showSortModal = true"></icon-halo>
                      <quick-edit
                        v-if="canEdit"
                        :editor="mediaEditor"
                        halo-theme="bg"
                        theme="lead"
                        position=""
                        :size="2"
                        position-offset="24"
                        :before-start-edit="
                          () => setMediaForEditing(founderMediaItem)
                        "
                        :fields="['title', 'featured']"></quick-edit>
                      <icon-halo
                        v-if="canEdit"
                        class="cursor-pointer z-level-2"
                        style="
                          top: var(--margin-s);
                          inset-inline-end: var(--margin-s);
                        "
                        halo-theme="danger"
                        theme="bg"
                        icon="trash"
                        :size="2"
                        @click="
                          startFounderMediaDeletion(founderMediaItem)
                        "></icon-halo>
                    </div>
                    <!--

                    todo: use pdf viewer when maximized to show PDF that is zoomable and scrollable
                    -->

                    <img
                      v-if="!sliderMaximized || founderMediaItem?.Media.mimeType !== 'application/pdf'"
                      class="founder-image"
                      style=""
                      :src="
                        founderMediaItem?.Media.mimeType === 'application/pdf'
                          ? getMediaThumbUrlSync(founderMediaItem?.Media, 600)
                          : founderMediaItem?.Media?.url
                      "
                      :alt="founderMediaItem?.title"
                      :class="
                      {
                        'founder-image__has-title' : isNonEmptyString(founderMediaItem.title),
                        'maximized animate__fadeIn animate--delay-200' : sliderMaximized
                      }"

                      @click="sliderMaximized = !sliderMaximized" />

                    <div class="founder-image founder-image--pdf flex-stretch flex-center "
                         v-if="sliderMaximized && founderMediaItem?.Media.mimeType === 'application/pdf'"

                    >
                      <component
                        v-if="!isSSR && PdfViewerComponent && isShowingPdfViewer"
                        :is="PdfViewerComponent"
                        class="pdf-viewer"
                        :style="{'max-width': pdfMaxWidth}"
                        @click="setPdfWidth(1000)"
                        :useSystemFonts="false"
                        :disableFontFace="true"
                        :progressColor="'red'"
                        :src="founderMediaItem?.Media?.url">
                        <template #pageTooltip="{currentPage, totalPages}">
                          <div
                            class="border-radius-s relative overflow-hidden inline-block flex-middle flex-center padding-s-vertical padding-m-horizontal">
                            <div class="absolute-cover z-index-1 counter-bg"
                                 style="background-color: rgba(0,0,0,0.6)"></div>
                            <div class="counter-content relative z-level-2 force-ltr flex flex-middle gap-m">
                              <span> {{ currentPage }} / {{ totalPages }}</span>


                            </div>
                          </div>
                        </template>
                        <template #backToTopBtn="{scrollOffset}">
                          <div class="flex gap-m flex-middle flex-center">
                            <icon-halo class="cursor-pointer"
                                       icon="arrow-download" halo-theme="inverse" theme="bg" size="1.5"
                                       v-tooltip="'ls.founder.downloadTooltip'"
                                       @click.prevent.stop="initiateDownload(founderMediaItem?.Media?.url, 'download.pdf')"></icon-halo>
                            <icon-halo class="cursor-pointer animate__fadeIn animate--faster"
                                       icon="magnify-plus" halo-theme="inverse" theme="bg" size="1.5"
                                       v-tooltip="'ls.founder.zoomInPdfTooltip'"
                                       v-if="canZoomPdfIn"
                                       @click.prevent.stop="zoomPdfIn()"></icon-halo>
                            <icon-halo class="cursor-pointer animate__fadeIn animate--faster"
                                       icon="magnify-minus" halo-theme="inverse" theme="bg" size="1.5"
                                       v-tooltip="'ls.founder.zoomOutPdfTooltip'"
                                       v-if="canZoomPdfOut"
                                       @click.prevent.stop="zoomPdfOut()"></icon-halo>

                            <icon-halo class="cursor-pointer animate__fadeIn animate--fastest"
                                       v-show="scrollOffset > 20"
                                       v-tooltip="'ls.founder.toTopTooltip'"
                                       icon="chevron-up" halo-theme="inverse" theme="bg" size="1.5"></icon-halo>

                          </div>

                        </template>
                      </component>


                    </div>
                    <div
                      v-if="
                        founderMediaItem.title && founderMediaItem.title != ''
                      "
                      class="image-description margin-s-top text-center">
                      <spoiler
                        v-show="!sliderMaximized"
                        class="image-title animate__fadeIn animate--fast"
                        max-height="30"
                        controls-theme="bg-1"
                        :controls-style="{ 'justify-content': 'center' }">
                        <template #default>
                          <span>{{ founderMediaItem.title }}</span>
                        </template>

                        <template
                          #controls="{
                            isExpanded,
                            expand,
                            contract,
                            shouldShowControls,
                          }">
                          <div
                            v-if="shouldShowControls"
                            class="flex-center margin-s-top padding-s-bottom">
                            <form-button
                              size="s"
                              v-if="shouldShowControls"
                              @click="isExpanded ? contract() : expand()"
                              theme="inverse"
                              :icon-end="
                                isExpanded ? 'chevron-up' : 'chevron-down'
                              "
                              :text="
                                isExpanded
                                  ? 'ls.spoiler.showLess'
                                  : 'ls.spoiler.showMore'
                              "></form-button>
                          </div>
                          <div v-else></div>
                        </template>
                      </spoiler>
                      <span v-show="sliderMaximized">{{
                          founderMediaItem.title
                        }}</span>
                    </div>
                  </div>
                </slide>
              </template>
              <template #navigation-prev>
                <span style="display: none"></span>
              </template>
              <template #navigation-next>
                <span style="display: none"></span>
              </template>
            </slider>
            <div
              v-if="hasMultipleMedia"
              class="swiper-button-prev-custom padding-xs"
              :class="sliderMaximized ? 'maximized animate__fadeIn animate--delay-200' : ''"
              @click.prevent.stop="$refs['imageSlider'].prev()">
              <icon icon="chevron-inline-start" :size="2" :theme="theme"></icon>
            </div>
            <div
              v-if="hasMultipleMedia"
              class="swiper-button-next-custom padding-xs"
              :class="sliderMaximized ? 'maximized animate__fadeIn animate--delay-200' : ''"
              @click.prevent.stop="$refs['imageSlider'].next()">
              <icon icon="chevron-inline-end" :size="2" :theme="theme"></icon>
            </div>
          </div>
          <div v-else="" class="media-slider relative flex flex-center">
            <form-button
              theme="success"
              icon="image"
              text="ls.founder.addImagesCta"
              @click="startCreatingFounderMedia" />
          </div>
          <icon-halo
            v-if="
              canEdit &&
              (!founder.FounderMedia || founder.FounderMedia.length < 1)
            "
            class="cursor-pointer absolute z-level-2"
            style="inset-inline-start: var(--margin-s); top: var(--margin-s)"
            halo-theme="success"
            theme="bg"
            icon="plus"
            :size="2"
            @click="startCreatingFounderMedia"></icon-halo>
        </div>

        <!--

        -->
      </div>
    </div>

    <item-orderer
      :as-modal="true"
      v-model:isOpen="showSortModal"
      modal-title="ls.founderMedia.sortUi.modalTitle"
      :items="displayMedia"
      :immediate-reorder="false"
      :item-exclusion-filter="isItemExcludedFromOrdering"
      endpoint="entity/FounderMedia/setOrdering"
      @itemOrderer:success="handleReorder">
      <template #item="{item}">
        <div class="flex-middle gap-m" style="min-width: 0;">
          <img
            class="border-radius-s bg-gray-1 padding-xs"
            style="
                height: calc(var(--base-margin) * 60);
                width: calc(var(--base-margin) * 60);
                object-fit: contain;
                object-position: center;
              "
            :src="item?.Media?.thumbUrl" />
          <strong class="text-l" v-if="item.featured">
            <icon-text
              icon="info"
              text="ls.founderMedia.sortUi.featuredImageExplain"></icon-text>
          </strong>
          <span class="text-overflow-ellipsis" v-else>{{
              item.title
            }}</span>
        </div>
      </template>
    </item-orderer>


    <modal
      :show="isCreatingFounderMedia"
      title="ls.founderMedia.feCreateTitle"
      size="2xl"
      :show-footer="false"
      @modal:closed="stopCreatingFounderMedia">
      <founder-media-uploader
        :founder-id="founder?.id"
        @fmu:upload-complete="
          founderMediaCreatedHandler
        "></founder-media-uploader>
    </modal>
    <youtube-video-modal
      class="founder-video-modal"
      :show="isShowingVideo"
      :video-id="currentVideoId"
      @modal:closed="isShowingVideo = false"></youtube-video-modal>
    <quick-editor v-bind="founderEditor.editorComponentConfig"></quick-editor>
    <quick-editor v-bind="mediaEditor.editorComponentConfig"></quick-editor>
  </div>
</template>

<script>
import useQuickEdit from "@/client/extensions/composition/useQuickEdit";
import { useStore } from "vuex";
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import { computed, watchEffect, ref, shallowRef, reactive, defineAsyncComponent } from "vue";
import FounderMediaUploader from "@/client/applications/localstory/components/founders/FounderMediaUploader";
import ItemOrderer from "@/client/applications/localstory/components/edit/ItemOrderer.vue";
import useMediaManager from "@/client/extensions/composition/useMediaManager";
import useDom from "@/client/extensions/composition/useDom";
import { isNonEmptyString } from "@/client/utilities";


export default {
  components: { FounderMediaUploader, ItemOrderer },
  props: {
    founderBoard: {
      type: [Object, Boolean],
      default: false,
    },
    founder: {
      type: [Object, Boolean],
      default: false,
    },
    bgTheme: {
      type: String,
      default: "bg",
    },
    theme: {
      type: String,
      default: "text",
    },
  },
  emits: [
    "founder:edited",
    "founder:mediaEdited",
    "founder:deleted",
    "founder:startedShowingVideo",
    "founder:stoppedShowingVideo",
  ],
  setup(props, { emit }) {
    // pdf viewer for client
    const PdfViewerComponent = ref(null);

    if (!utilities.isSSR()) {
      import("pdf-vue3")
        .then(m => {
          PdfViewerComponent.value = m.default || m;
        })
        .catch(console.error);
    }

    let store = useStore();
    let { getMediaThumbUrlSync } = useMediaManager();
    let { asyncOps, asyncOpsReady } = asyncOperations(props);
    const { initiateDownload } = useDom();
    let canEdit = ref(false);
    let { editor: founderEditor } = useQuickEdit({
      target: "founder",
      form: "founder",
      enabled: false,
      formData: { userProfile: store },
      callback: (arg, instance) => {
        return true;
      },
      endpoint: computed(() => `founder/${props.founder.id}`),
    });

    const mediaEditTarget = reactive({});

    let { editor: mediaEditor } = useQuickEdit({
      target: mediaEditTarget,
      form: "founderMedia",
      enabled: canEdit,
      refreshAsyncDataOnSuccess: true,
      formData: { userProfile: useStore() },
      endpoint: "", // dynamic, set in runtime
      callback: (arg, instance) => {
        emit("founder:mediaEdited");
        try {
          if (typeof instance.ctx.resetSliders === "function") {
            instance.ctx.resetSliders();
          }
        } catch (e) {
        }

        return true;
      },
    });

    watchEffect(() => {
      let profile = store.getters["user/profile"];
      if (!profile) {
        canEdit.value = false;
        return founderEditor.disable();
      }
      let ownsBoard = profile?.FounderBoard?.alias == props?.founderBoard.alias;
      if (profile?.isSuperAdmin || ownsBoard) {
        canEdit.value = true;
        return founderEditor.enable();
      }
      canEdit.value = false;
      founderEditor.disable();
    });

    return {
      PdfViewerComponent,
      asyncOps,
      asyncOpsReady,
      founderEditor,
      canEdit,
      mediaEditor,
      mediaEditTarget,
      getMediaThumbUrlSync,
      initiateDownload,
    };
  },
  data: function() {
    return {
      currentVideoId: false,
      newFounderMediaData: {
        FounderId: this?.founder?.id,
      },
      isCreatingFounderMedia: false,
      isShowingVideo: false,
      founderMediaFormOverrides: {
        fields: {
          MediaId: { type: "LsSelectMedia" },
          FounderId: { type: "hidden" },
        },
      },
      uid: new Date().getTime() + "_" + utilities.getUniqueNumber(),
      mediaSliderConfig: {
        loop: true,
        //slidesPerView: 1,
        // spaceBetween: 20,
        breakpoints: {
          767: {
            // slidesPerView: 3,
          },
        },
        pagination: false,
        observer: true,
        observeParents: true,
        parallax: true,
        // Navigation arrows
        // navigation: {
        // nextEl: ".swiper-button-next-custom",
        //prevEl: ".swiper-button-prev-custom",
        //  },
      },
      videoSliderConfig: {
        loop: true,
        //slidesPerView: 1,
        // spaceBetween: 20,
        breakpoints: {
          767: {
            // slidesPerView: 3,
          },
        },
        pagination: false,
        observer: true,
        observeParents: true,
        parallax: true,
        autoHeight: true,
        // Navigation arrows
        // navigation: {
        // nextEl: ".swiper-button-next-custom",
        //prevEl: ".swiper-button-prev-custom",
        //  },
      },
      sliderMaximized: false,
      newOrder: null,
      showSortableUi: true,
      showSortModal: false,
      isMounted: false,
      pdfWidth: 800,
      isShowingPdfViewer: true,
      maxPdfWidth: 1400,
      minPdfWidth: 200,
      zoomPdfStep: 200,
    };
  },

  computed: {
    pdfMaxWidth() {

      return `clamp(${this.pdfWidth}px,${this.pdfWidth}px,100%)`;
    },
    isSSR() {
      return utilities.isSSR();
    },
    bgThemeProperty() {
      return `var(--c-${this.bgTheme})`;
    },
    themeProperty() {
      return `var(--c-${this.theme})`;
    },
    youtubeVideos() {
      if (!Array.isArray(this.founder?.youtubeVideos)) {
        return false;
      }

      return this.founder?.youtubeVideos;
    },
    hasImages() {
      return this.founder.FounderMedia && this.founder.FounderMedia.length > 0;
    },
    hasMultipleImages() {
      return this.founder.FounderMedia && this.founder.FounderMedia.length > 1;
    },
    hasMultipleMedia() {
      let mediaLength = this.founder.FounderMedia ? this.founder.FounderMedia.length : 0;
      let videosLength = this.hasVideos ? this.founder.youtubeVideos.length : 0;
      return +mediaLength + videosLength > 1;
    },
    hasVideos() {
      return (
        this.founder.youtubeVideos && this.founder.youtubeVideos.length > 0
      );
    },
    hasMultipleVideos() {
      return (
        this.founder.youtubeVideos && this.founder.youtubeVideos.length > 1
      );
    },
    displayMedia() {
      if (
        !this.founder ||
        !this.founder.FounderMedia ||
        !Array.isArray(this.founder.FounderMedia)
      ) {
        return [];
      }

      let featuredItem = false;
      let result = this.founder.FounderMedia.slice()
        .sort((a, b) => a.order - b.order)
        .filter((item) => item.featured !== true);

      this.founder.FounderMedia.forEach((item) => {
        if (item.featured) {
          featuredItem = item;
          return true;
        }
      });

      if (featuredItem) {
        result.unshift(featuredItem);
      }
      return result;
    },
    hasCountryAndYear() {
      let hasCountry = this.founder.originCountry && this.founder.originCountry !== "";
      let hasBirthYear = this.founder.birthYear && this.founder.birthYear !== "";
      let hasDeathYear = this.founder.deathYear && this.founder.deathYear !== "";

      return hasCountry && (hasBirthYear || hasDeathYear);


      return true;
    },
    canZoomPdfIn() {
      return this.pdfWidth < this.maxPdfWidth;
    },
    canZoomPdfOut() {
      return this.pdfWidth > this.minPdfWidth;
    },
  },
  watch: {
    founder: {
      handler(newVal, oldVal) {
        this.showSortableUi = true;
        if (newVal.FounderMedia.length === oldVal.FounderMedia.length) {
          return;
        }
        if (utilities.isSSR()) {
          this.$nextTick(() => {
            this.resetSliders();
          });
        } else {
          setTimeout(() => {
            this.resetSliders();
          }, 200);
        }
      },
      deep: true,
    },
    isShowingVideo(newVal) {
      if (newVal) {
        this.$emit("founder:startedShowingVideo");
      } else {
        this.$emit("founder:stoppedShowingVideo");
      }
    },
  },
  activated() {
    this.sliderMaximized = false;
  },
  mounted() {
    this.sliderMaximized = false;
    this.isMounted = true;
  },
  methods: {
    isNonEmptyString,
    async setMediaForEditing(media) {
      this.mediaEditor.setTarget(media);
      this.mediaEditor.setEndpoint(`founder-media/${media.id}`);
      await utilities.nextTick();
      return true;
    },
    founderMediaCreatedHandler(res) {
      this.$s.ui.notification("core.successGeneric", "success");
      this.stopCreatingFounderMedia();
      //this.resetFounderMediaCreateData();
      this.refreshAsyncData();
      this.$emit("founder:edited");
      setTimeout(() => {
        this.resetSliders();
      }, 500);
    },
    resetFounderMediaCreateData() {
      this.newFounderMediaData = { FounderId: this?.founder.id };
    },
    stopCreatingFounderMedia() {
      this.isCreatingFounderMedia = false;
    },
    startCreatingFounderMedia() {
      this.isCreatingFounderMedia = true;
    },
    resetSliders() {
      try {
        if (this.$refs["imageSlider"]) {
          this.$refs["imageSlider"].reset();
        }
        if (this.$refs["videoSlider"]) {
          this.$refs["videoSlider"].reset();
        }
      } catch (e) {
        console.log(e);
      }
    },
    startFounderMediaDeletion(item) {
      this.$s.ui.modal
        .confirm("core.deleteModalConfirmText")
        .then(() => {
          this.deleteFounderMedia(item);
        })
        .catch(() => {
          this.$s.ui.notification("core.actionCanceled");
        });
    },
    startFounderDeletion() {
      this.$s.ui.modal
        .confirm("core.deleteModalConfirmText")
        .then(() => {
          this.deleteFounder();
        })
        .catch(() => {
          this.$s.ui.notification("core.actionCanceled");
        });
    },
    async deleteFounderMedia(item) {
      // spinner
      this.isLoading = true;
      let res = await this.asyncOps.asyncCall(
        `founder-media/${item.id}`,
        {},
        { method: "delete" },
      );

      if (res.hasError) {
        this.$s.ui.notification("core.errorGeneric", "error");
        this.isLoading = false;
        return false;
      }

      this.$s.ui.notification("core.successGeneric", "success");
      this.isLoading = false;
      this.$emit("founder:edited");
      return true;
    },
    async deleteFounder() {
      // spinner
      this.isLoading = true;
      let res = await this.asyncOps.asyncCall(
        `founder/${this.founder.id}`,
        {},
        { method: "delete" },
      );

      if (res.hasError) {
        this.$s.ui.notification("core.errorGeneric", "error");
        this.isLoading = false;
        return false;
      }

      this.$s.ui.notification("core.successGeneric", "success");
      this.isLoading = false;
      this.$emit("founder:deleted");
      return true;
    },
    playLargeVideo(videoId) {
      this.currentVideoId = videoId;
      this.isShowingVideo = true;
    },
    isItemExcludedFromOrdering(item) {
      return !!item.featured;
    },
    async onReorder(e, b) {
      let item1, order1, item2, order2;
      item1 = this.displayMedia[e.newIndex];
      order1 = e.oldIndex;
      item2 = this.displayMedia[e.oldIndex];
      order2 = e.newIndex;

      let updateData = {};
      if (order1 > order2) {
        // the item2 is FIRST
        updateData[0] = item2.id;
        updateData[1] = item1.id;
      } else {
        // item2 is LAST
        updateData[0] = item1.id;
        updateData[1] = item2.id;
      }

      let reqData = { newOrdering: updateData, entityType: "FounderMedia" };
      let result = await this.asyncOps.asyncCall(
        `entity/FounderMedia/setOrdering`,
        reqData,
        {
          method: "patch",
        },
      );
      this.showSortableUi = false; // this will reset the sortable. it will be turned back to true once the founder is updated

      this.$nextTick(() => {
        this.showSortableUi = true;
      });


      setTimeout(() => {
        this.resetSliders();
      }, 400);
    },
    handleReorder(data) {
      this.$emit("founder:edited");
      this.showSortModal = false;
      setTimeout(() => {
        this.resetSliders();
      }, 400);
    },
    setPdfWidth(size) {
      this.pdfWidth = size;
      this.isShowingPdfViewer = false;
      this.$nextTick(() => {
        this.isShowingPdfViewer = true;
      });
    },
    zoomPdfIn() {
      let next = this.pdfWidth + this.zoomPdfStep;
      if (next >= this.pdfMaxWidth) {
        this.setPdfWidth(this.maxPdfWidth);
      } else {
        this.setPdfWidth(next);
      }
    },
    zoomPdfOut() {
      let next = this.pdfWidth - this.zoomPdfStep;
      if (next <= this.minPdfWidth) {
        this.setPdfWidth(this.minPdfWidth);
      } else {
        this.setPdfWidth(next);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.founder--full {
  .founder-content-wrap {
    gap: var(--margin-2xl);

    @media (max-width: 1024px) {
      flex-wrap: wrap;
    }

    @media (max-width: 768px) {
      gap: var(--margin-m);
    }
  }

  .founder-bio {
    flex: calc(var(--base-margin) * 700);

    @media (max-width: 1024px) {
      flex: 100%;
    }

    :deep(p) {
      font-size: calc(var(--font-l) * 1.1);
    }

    @media (max-width: 1024px) {
      order: 2;
    }
  }

  .founder-heading {
    margin-bottom: var(--margin-2xl);

    @media (max-width: 1024px) {
      text-align: center;
      margin-top: var(--margin-xl);
      margin-bottom: var(--margin-l);
    }

    @media (max-width: 767px) {
      text-align: center;
      margin-top: var(--margin-l);
      margin-bottom: var(--margin-xs);
    }

    .founder-meta,
    .founder-title {
      line-height: 0;
    }
  }

  .founder-media {
    max-height: calc(95lvh - 100px);
    flex: 0 0 calc(var(--base-margin) * 700);

    @media (max-width: 1024px) {
      max-height: 100%;
      order: 1;
      width: 100%;
      flex: 100%;
    }


    .edit-video-cta {
      @media (max-width: 1024px) {
        top: -46px;
      }
    }
  }

  .slider-wrapper {
    height: calc(var(--base-margin) * 625);
    align-items: center; /* keeps cross-axis centred   */
    justify-content: center; /* keeps main-axis centred    */
    @media (max-width: 1024px) {
      height: auto;
    }
  }

  .media-slider {
    // these sizes relate to full hd desktop specifically
    height: calc(var(--base-margin) * 450);
    width: calc(var(--base-margin) * 650);
    max-width: 100%;
    @media (max-width: 1024px) {
      max-width: calc(100% - 10vw - 50 * var(--base-margin));
    }
    @media (max-width: 767px) {
      max-width: calc(370 * var(--base-margin));
    }
    @media (max-width: 500px) {
      height: auto;
      width: calc(var(--base-margin) * 205);
    }

    .video-slide {
      height: calc(var(--base-margin) * 300);
      width: calc(var(--base-margin) * 500);
      max-height: 100%;
      object-fit: cover;
    }


    .video-preview-image {
      object-fit: fill;
      // flex: 2 2 320px;
      max-height: 100%;
      max-width: 100%;
      width: 80%;
      height: auto;
    }

    .maximized-slider-close {
      position: absolute;
      top: var(--margin-m);
      inset-inline-end: var(--margin-m);
      z-index: var(--z-2);
    }

    .image-title {
      max-width: calc(var(--base-margin) * 800);
      margin-inline: auto;
    }

    &.maximized {
      position: fixed;
      width: 100%;
      height: 100%;
      min-width: 100%;
      top: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.8);
      z-index: var(--z-top-2);


      .founder-image {
        max-width: 90%;
        max-height: 90%;
        width: 90%;
        height: 90%;
        object-fit: contain !important;


        //

        @media (max-width: 500px) {
          max-width: 100%;
          max-height: 100%;
          width: 100%;
          height: 100%;
          object-fit: contain !important;
        }
      }

      // pdf image - maximized mode is pdf viewer
      .founder-image.founder-image--pdf {
        background: var(--c-bg);
        padding: var(--margin-xl);
        border-radius: var(--border-radius);

        .pdf-viewer {
          flex: 100%;
          width: 500px;
          height: 100%;
          max-width: 1400px;
        }
      }

      // when pdf viewer has also text below
      :has(.image-description) .founder-image--pdf {
        max-height: calc(100lvh - 200px);
        margin-top: 40px;
      }
    }
  }

  .founder-media-slide {
    max-height: calc(95lvh - 100px);
    align-self: flex-start; /* or 'center', 'flex-end' */
    /* – OR – */
    flex: 0 0 auto; /* don’t let it grow or shrink */

    @media (max-height: 750px) and (min-width: 1024px) {
      max-height: calc(95lvh - 200px);
    }

  }

  .founder-image {

    // max-height: 350px;
    // max-width: 500px;
    //  height: 100%;
    // width: 100%;
    object-fit: contain;
    // flex: 2 2 320px;
    flex: 1 1 0; /* may grow, may shrink, basis 0  */
    min-height: 0; /* <-- crucial for Chrome         */
    display: flex; /* lets you centre the bitmap     */
    justify-content: center;
    align-items: center;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain; /* stop distortion / cropping     */

    &__has-title {
      // flex: 100%;
      // max-height:calc(100% - var(--base-margin) * 80);
    }

    @media (max-width: 1024px) {
      object-fit: contain;
    }

    @media (max-width: 500px) {
      height: calc(var(--base-margin) * 140);
      width: calc(var(--base-margin) * 205);
    }
  }

  .image-description {
    flex: 0 0 auto;
    //  padding-bottom: 3em;
  }

  .media-slider-placeholder {
    height: calc(var(--base-margin) * 180);
    width: calc(var(--base-margin) * 275);

    @media (max-width: 500px) {
      height: calc(var(--base-margin) * 140);
      width: calc(var(--base-margin) * 205);
    }
  }

  .video-container {
    height: auto;
    width: calc(var(--base-margin) * 600);
    margin-inline: auto;

    @media (max-width: 500px) {
      height: calc(var(--base-margin) * 140);
      width: calc(var(--base-margin) * 205);
    }
  }

  .swiper-button-prev-custom {
    position: absolute;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
    inset-inline-start: calc(var(--base-margin) * 30 * -1);
    z-index: var(--z-4);

    &::after {
      display: none;
    }

    &.maximized {
      // margin-inline-end: calc(100% - 50px);
      margin-inline-end: 0;
      inset-inline-start: calc(var(--base-margin) * 10);
      transform: translateY(-50%) scale(2, 2);
      z-index: var(--z-top-1);
    }
  }

  .swiper-button-next-custom {
    position: absolute;
    top: 50%;
    cursor: pointer;
    transform: translateY(-50%);
    inset-inline-end: calc(var(--base-margin) * 30 * -1);
    z-index: var(--z-4);

    &::after {
      display: none;
    }

    &.maximized {
      margin-inline-start: 0;
      inset-inline-end: calc(var(--base-margin) * 10);
      transform: translateY(-50%) scale(2, 2);
      z-index: var(--z-top-1);
    }
  }
}
</style>

<style lang="scss">
.founder-video-modal {
  .modal__icon-close {
    transform: scale(1.25, 1.25);
    background-color: var(--c-bg) !important;
    border: 2px solid var(--c-lead) !important;
    top: var(--margin-l);
    inset-inline-end: var(--margin-l);

    .icon {
      background-color: var(--c-lead) !important;
    }
  }
}

.pdf-viewer {
  .pdf-vue3-backToTopBtn {
    opacity: 1 !important;
    pointer-events: auto !important;
  }
}
</style>
